import { DOMExportOutput } from 'lexical';
import {
  ReferenceCitationSeparator,
  ReferenceCitationSeparatorNode,
} from 'modules/Lexical/nodes/ReferenceCitationSeparatorNode';

export class ReferenceCitationSeparatorNodeWithExportDom extends ReferenceCitationSeparatorNode {

  constructor(key?: string) {
    super(ReferenceCitationSeparator.COMMA, key);
  }

  static getType(): string {
    return super.getType() + '-export';
  }

  static clone(node: ReferenceCitationSeparatorNodeWithExportDom): ReferenceCitationSeparatorNodeWithExportDom {
    return new ReferenceCitationSeparatorNodeWithExportDom(node.__key);
  }

  static importJSON(): ReferenceCitationSeparatorNodeWithExportDom {
    return new ReferenceCitationSeparatorNodeWithExportDom();
  }

  exportDOM(): DOMExportOutput {
    return { element: null };
  }
}
